import { flow } from 'lodash';
import Reorder from './Reorder';
import withUserInput from '../../hocs/UserInput';
import withValidation from '../../hocs/Validation';

export default flow(withUserInput, withValidation)(Reorder);



// WEBPACK FOOTER //
// ../core/src/components/Reorder/index.js